import { getDocRef, getRootCollection } from './queries'
export const listCompanies = () => getRootCollection('companies')

export const getCompanyForAccount = getDocRef(listCompanies)
